import {
  LayoutDashboard,
  Building2,
  Users,
  Package,
  GitBranch,
  Lightbulb,
  FileText,
  DollarSign,
  BotMessageSquare,
  Settings,
  Calendar,
  ShieldCheck,
  StickyNote,
  Workflow,
  ChevronRight,
  ChevronDown,
  Plus,
  MoreHorizontal,
  Star,
  Clock,
  Folder,
  MoreVertical,
  Briefcase,
  Search,
  Shield,
  TrendingUp,
  Sparkles,
  Zap,
  User,
  FlaskConical,
  BarChart3,
  PiggyBank,
  Headset,
  Truck,
  Factory,
  CheckCircle,
  Server,
  Database,
  BookOpen,
  Brain,
  Tag,
  MessageCircle,
  HeartPulse,
  Globe,
  Store,
  ShoppingBasket,
  Share2,
  ShoppingCart,
  PenLine,
  FileQuestion,
} from 'lucide-react';

const iconMap: Record<string, React.ComponentType<{ size?: number; className?: string }>> = {
  LayoutDashboard,
  Building2,
  Users,
  Package,
  GitBranch,
  Lightbulb,
  FileText,
  DollarSign,
  BotMessageSquare,
  Settings,
  Calendar,
  ShieldCheck,
  StickyNote,
  Workflow,
  ChevronRight,
  ChevronDown,
  Plus,
  MoreHorizontal,
  Star,
  Clock,
  Folder,
  MoreVertical,
  Briefcase,
  Search,
  Shield,
  TrendingUp,
  Sparkles,
  Zap,
  User,
  FlaskConical,
  BarChart3,
  PiggyBank,
  Headset,
  Truck,
  Factory,
  CheckCircle,
  Server,
  Database,
  BookOpen,
  Brain,
  Tag,
  MessageCircle,
  HeartPulse,
  Globe,
  Store,
  ShoppingBasket,
  Share2,
  ShoppingCart,
  PenLine,
  FileQuestion,
};

export function resolveIcon(name?: string): React.ComponentType<{ size?: number; className?: string }> | null {
  if (!name) return null;
  return iconMap[name] || null;
}
